import { render, staticRenderFns } from "./ItemL_List_PackagingList.vue?vue&type=template&id=7cfef757"
import script from "./ItemL_List_PackagingList.vue?vue&type=script&lang=js"
export * from "./ItemL_List_PackagingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports